module.exports = __webpack_public_path__ + "img/DiaryBarham-PakwXaweni.62b17312.jpg";